<div class="container-fluid d-flex align-items-center justify-content-center flex-column h-100 px-0"  *ngIf="currentPlan?.currentPlanModel">
    <div class="card m-0 p-3" style="width: 28rem;">
        <div class="d-flex flex-row custom-gap align-items-center">
            <div class="d-flex flex-column justify-content-center align-items-center">
                <h4 class="text-white font-14 m-0">Plan Validity</h4>
                <span class="text-white font-14">{{currentPlan?.currentPlanModel?.planValidity}}</span>
                <!-- <apx-chart 
                    [series]="chartOptions.series" 
                    [chart]="chartOptions.chart"
                    [plotOptions]="chartOptions.plotOptions" 
                    [labels]="chartOptions.labels"
                    [legend]="chartOptions.legend" 
                    [colors]="chartOptions.colors"
                    >
                </apx-chart> -->
            </div>
            <div class="col my-auto plan-details">
                <div class="d-flex justify-content-between mb-2">
                    <div class="col">
                        Membership
                    </div>
                     <div class="col">
                        :
                    </div>
                    <div class="col">
                        {{currentPlan?.currentPlanModel?.planMemberShip}}
                    </div>
                </div>
                <div class="d-flex justify-content-between mb-2">
                    <div class="col">
                        Renewal On
                    </div>
                    <div class="col">
                        :
                    </div>
                    <div class="col">
                        {{currentPlan?.currentPlanModel?.renewalOn}}
                    </div>
                </div>
                <div class="d-flex justify-content-between mb-2">
                    <div class="col">
                        Renewal Amt.
                    </div>
                     <div class="col">
                        :
                    </div>
                    <div class="col">
                        {{currentPlan?.currentPlanModel?.renewalAmount}}
                    </div>
                </div>
                <div class="d-flex justify-content-between mb-2">
                    <div class="col">
                        Expires On
                    </div>
                     <div class="col">
                        :
                    </div>
                    <div class="col">
                        {{currentPlan?.currentPlanModel?.expiresOn}} </div>
                </div>
            </div>
        </div>
    </div>
</div>